import BoardDetail from "pages/cs/Detail";
import Event from "pages/cs/Event";
import Faq from "pages/cs/Faq";
import Notice from "pages/cs/Notice";
import Main from "pages/main/Main";
import Social from "pages/member/Social";
import Alarm from "pages/mypage/Alarm";
import Coupon from "pages/mypage/Coupon";
import Edit from "pages/mypage/Edit";
import Mypage from "pages/mypage/Mypage";
import Point from "pages/mypage/Point";
import Setting from "pages/mypage/Setting";
import NavigationPage from "pages/private/Navigation";
import PaymentSuccessPage from "pages/private/Payment";
import PublicOnly from "pages/private/PublicOnly";
import RentDetail from "pages/rent/Detail";
import RentList from "pages/rent/List";
import RentPayment from "pages/rent/Payment";
import RentReservation from "pages/rent/Reservation";
import ReservationDetail from "pages/reservation/Detail";
import ReservationEdit from "pages/reservation/Edit";
import ReservationEditCarList from "pages/reservation/EditCarList";
import ReservationEditDate from "pages/reservation/EditDate";
import ReservationList from "pages/reservation/List";
import React from "react";
import { Navigate } from "react-router-dom";

//type
//login : 로그인 한정 페이지
// notLogin : 비로그인 한정 페이지
// null : 로그인,비로그인 무관 페이지

export const routes = [
    {
        exact: true,
        path: "/pageErr",
        component: <PublicOnly/>,
        type : null
    },
    {
        exact: true,
        path: "/pageErr/:err",
        component: <PublicOnly/>,
        type : null
    },
    {
        exact: true,
        path: "/",
        component: <Navigate to="/main" />,
        type : null
    },
    {
        exact: true,
        path: "/main",
        component: <Main/>,
        type : null
    },
    {
        exact: true,
        path: "/paymentModal",
        component: <PaymentSuccessPage/>,
        type : null
    },
    {
        exact: true,
        path: "/social/:type",
        component: <Social/>,
        type : null
    },
    {
        exact: true,
        path: "/navi/:type",
        component: <NavigationPage/>,
        type : null
    },
    {
        exact: true,
        path: "/reservation",
        component: <ReservationList/>,
        type : "login"
    },
    {
        exact: true,
        path: "/reservation/detail/:id",
        component: <ReservationDetail/>,
        type : null
    },
    {
        exact: true,
        path: "/reservation/edit/:id",
        component: <ReservationEdit/>,
        type : null
    },
    {
        exact: true,
        path: "/reservation/edit/date/:id",
        component: <ReservationEditDate/>,
        type : null
    },
    {
        exact: true,
        path: "/reservation/edit/list/:id",
        component: <ReservationEditCarList/>,
        type : null
    },
    {
        exact: true,
        path: "/rent/list",
        component: <RentList/>,
        type : null
    },
    {
        exact: true,
        path: "/:type/detail/:id/:cCode/:mCode",
        component: <RentDetail/>,
        type : null
    },
    {
        exact: true,
        path: "/rent/reservation",
        component: <RentReservation/>,
        type : null
    },
    {
        exact: true,
        path: "/:type/payment",
        component: <RentPayment/>,
        type : null
    },
    {
        exact: true,
        path: "/faq",
        component: <Faq/>,
        type : null
    },
    {
        exact: true,
        path: "/event",
        component: <Event/>,
        type : null
    },
    {
        exact: true,
        path: "/notice",
        component: <Notice/>,
        type : null
    },
    {
        exact: true,
        path: "/:type/detail/:id",
        component: <BoardDetail/>,
        type : null
    },
    {
        exact: true,
        path: "/mypage",
        component: <Mypage/>,
        type : "login"
    },
    {
        exact: true,
        path: "/alarm",
        component: <Alarm/>,
        type : "login"
    },
    {
        exact: true,
        path: "/mypage/point",
        component: <Point/>,
        type : "login"
    },
    {
        exact: true,
        path: "/mypage/coupon",
        component: <Coupon/>,
        type : "login"
    },
    {
        exact: true,
        path: "/mypage/setting",
        component: <Setting/>,
        type : "login"
    },
    {
        exact: true,
        path: "/mypage/profile",
        component: <Edit/>,
        type : "login"
    },
    
];